import { Typography, Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import 'swiper/css';
import { SignUpCarouselSlideBox, TipBox, TipBoxTitle } from './styles';

interface SignUpCarouselSlideProps {
  number: number;
  titleId: string;
  titleImage?: ReactNode;
  descriptionImage?: ReactNode;
  topDescriptionId?: string;
  bottomDescriptionId?: string;
}

const SignUpCarouselSlide: React.FC<SignUpCarouselSlideProps> = ({
  number,
  titleId,
  titleImage,
  descriptionImage,
  topDescriptionId,
  bottomDescriptionId,
}) => {
  return (
    <SignUpCarouselSlideBox>
      <TipBox>
        <TipBoxTitle>
          <FormattedMessage id="signup.carousel.tip" values={{ number }} />
        </TipBoxTitle>
      </TipBox>
      <Stack sx={{ mt: '8px', flexDirection: 'row', alignItems: 'center', gap: '16px' }}>
        {titleImage}
        <Typography variant="h2">
          <FormattedMessage id={titleId} />
        </Typography>
      </Stack>
      <Typography sx={{ mt: '16px' }}>
        <FormattedMessage
          id={topDescriptionId}
          values={{
            b: (word) => <b>{word}</b>,
          }} />
      </Typography>
      {descriptionImage}
      {bottomDescriptionId && (
        <Typography>
          <FormattedMessage id={bottomDescriptionId} />
        </Typography>
      )}
    </SignUpCarouselSlideBox>
  );
};

export default SignUpCarouselSlide;
